import createIcon from '../../createIcon';

/**
 * @component @name MonochromePhotos
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgNUgxNi44TDE1IDNIOUw3LjIgNUg0QzIuOSA1IDIgNS45IDIgN1YxOUMyIDIwLjEgMi45IDIxIDQgMjFIMjBDMjEuMSAyMSAyMiAyMC4xIDIyIDE5VjdDMjIgNS45IDIxLjEgNSAyMCA1Wk0yMCAxOUgxMlYxOEM5LjIgMTggNyAxNS44IDcgMTNDNyAxMC4yIDkuMiA4IDEyIDhWN0gyMFYxOVpNMTcgMTNDMTcgMTAuMiAxNC44IDggMTIgOFY5LjhDMTMuOCA5LjggMTUuMiAxMS4yIDE1LjIgMTNDMTUuMiAxNC44IDEzLjggMTYuMiAxMiAxNi4yVjE4QzE0LjggMTggMTcgMTUuOCAxNyAxM1pNOC44IDEzQzguOCAxNC44IDEwLjIgMTYuMiAxMiAxNi4yVjkuOEMxMC4yIDkuOCA4LjggMTEuMiA4LjggMTNaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const MonochromePhotos = createIcon('MonochromePhotos', [
  [
    'path',
    {
      d: 'M20 5H16.8L15 3H9L7.2 5H4C2.9 5 2 5.9 2 7V19C2 20.1 2.9 21 4 21H20C21.1 21 22 20.1 22 19V7C22 5.9 21.1 5 20 5ZM20 19H12V18C9.2 18 7 15.8 7 13C7 10.2 9.2 8 12 8V7H20V19ZM17 13C17 10.2 14.8 8 12 8V9.8C13.8 9.8 15.2 11.2 15.2 13C15.2 14.8 13.8 16.2 12 16.2V18C14.8 18 17 15.8 17 13ZM8.8 13C8.8 14.8 10.2 16.2 12 16.2V9.8C10.2 9.8 8.8 11.2 8.8 13Z',
      key: '11t1l9',
    },
  ],
]);

export default MonochromePhotos;
